interface PageLoadingProps {
  message?: string;
  compact?: boolean;
}

export default function PageLoading({ message = '加载中…', compact = false }: PageLoadingProps) {
  return (
    <div className={compact ? 'flex items-center gap-3 text-apple-gray text-[0.875rem]' : 'flex flex-col items-center justify-center h-64 gap-3'}>
      <div className='w-8 h-8 rounded-full border-2 border-apple-blue border-t-transparent animate-spin' />
      <span className='text-apple-gray text-[0.875rem]'>{message}</span>
    </div>
  );
}
